// "Do next" (Overview) and the Wellness tiles. Pure + unit-tested.
// Phase 1 has no SMS read state, so unread texts are NOT an attention source yet.
import { UPCOMING_DAYS, addDays, fmtDay } from './conciergeTodoModel';
import { calendarParts, daysSince, fmtMonDay, toDate } from './conciergeActivityModel';

export const WELLNESS_STALE_DAYS = 30;
const CLOSED = ['done', 'na'];
const RANK = { red: 0, amber: 1, neutral: 2 };
const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
  'August', 'September', 'October', 'November', 'December'];

function lateDays(dueIso, todayIso) {
  return Math.round((Date.parse(`${todayIso}T00:00:00Z`) - Date.parse(`${dueIso}T00:00:00Z`)) / 86400000);
}

export function buildDoNext({ tasks = [], lastWellnessAt = null, todayIso, now = new Date() }) {
  const horizon = addDays(todayIso, UPCOMING_DAYS);
  const rows = [];
  for (const t of tasks || []) {
    if (CLOSED.includes(t.status) || !t.due_at) continue;
    const tone = t.due_at < todayIso ? 'red' : (t.due_at <= horizon ? 'amber' : 'neutral');
    rows.push({
      key: `task-${t.id}`, taskId: t.id, title: t.title, due: t.due_at, tone,
      sub: t.note || (t.waiting_on ? `Waiting on ${t.waiting_on}` : (t.is_recurring ? 'Recurring' : '')),
      pill: tone === 'red' ? `${lateDays(t.due_at, todayIso)}d overdue` : fmtDay(t.due_at),
    });
  }
  const n = daysSince(lastWellnessAt, now);
  if (n === null || n > WELLNESS_STALE_DAYS) {
    rows.push({
      key: 'wellness', taskId: null, title: 'Wellness check-in', due: '', tone: 'amber',
      sub: n === null ? 'None logged yet' : `None logged since ${fmtMonDay(lastWellnessAt)}`,
      pill: n === null ? 'Never' : `${n} days`,
    });
  }
  rows.sort((a, b) => RANK[a.tone] - RANK[b.tone] || (a.due || '').localeCompare(b.due || ''));
  return rows.map(({ due, ...r }) => r);
}

export function attentionCount(rows) {
  return (rows || []).filter(r => r.tone !== 'neutral').length;
}

function latestFor(checks, field) {
  const hits = (checks || []).filter(c => c[field] != null)
    .sort((a, b) => (toDate(b.created_at)?.getTime() || 0) - (toDate(a.created_at)?.getTime() || 0));
  if (!hits.length) return null;
  return { value: hits[0][field], prev: hits[1] ? hits[1][field] : null, prevAt: hits[1] ? hits[1].created_at : null };
}

export function latestScores(checks) {
  return { mental: latestFor(checks, 'mental_score'), sleep: latestFor(checks, 'sleep_score') };
}

export function scoreTone(v) { return v <= 2 ? 'red' : (v === 3 ? 'amber' : 'ink'); }
export function barTone(v) { return v <= 2 ? 'red' : (v === 3 ? 'amber' : 'green'); }

export function trendText(s) {
  if (!s || s.prev == null) return '';
  const month = MONTH_NAMES[calendarParts(s.prevAt).m];
  if (s.value < s.prev) return `Down from ${s.prev} in ${month}`;
  if (s.value > s.prev) return `Up from ${s.prev} in ${month}`;
  return `Same as ${month}`;
}
